import * as React from 'react';
export const SvgFireExtinguisher = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M11 2.184v-.467l3.276.582s.016-.97-3.276-1.26v-.021C13.67.782 13.884 0 13.884 0L11 .306V0H9v.5H8a4.005 4.005 0 00-4 4V9l-1 2v5h3v-5L5 9V4.5a3.003 3.003 0 013-3h1v.684A2.991 2.991 0 007 5v10.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5V5a2.991 2.991 0 00-2-2.816z' })));
};
export default SvgFireExtinguisher;
